import { render } from "./curator-roles.vue?vue&type=template&id=ff8bd344"
import script from "./curator-roles.vue?vue&type=script&lang=js"
export * from "./curator-roles.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__